import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
// import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  formatCurrency,
  formatterStatus,
  replaceNulls,
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  sizePerPageList,
  statusFormatter,
} from "../../utility";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { editItem, removeById } from "./paramSlice";
import { useDispatch } from "react-redux";

export const ParamTable = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  loading,
}) => {
  // const dispatch = useDispatch();
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    // Add number
    const pageBefore = sizePerPage * (page - 1);
    const initData = data.map((item, index) => {
      const newItem = replaceNulls(item);
      return {
        ...newItem,
        no: index + 1 + pageBefore,
      };
    });

    console.log(initData);
    setTableData(initData);
  }, [data, sizePerPage, page]);

  const [tableData, setTableData] = useState(data);

  const actionFormatter = (e, row) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
        >
          <div
            className="btn btn-icon btn-light btn-hover-danger btn-sm mr-3"
            onClick={() => {
              history.push(
                `/administration/param/edit/${row.company_param_id}`
              );
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-secondary">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")} />
            </span>
          </div>
        </OverlayTrigger>

        {row.is_active === true && (
          <OverlayTrigger
            overlay={<Tooltip id="products-delete-tooltip">Not Active</Tooltip>}
          >
            <div
              className="btn btn-icon btn-light btn-hover-danger btn-sm mr-3 mb-2"
              onClick={() => handleNotActive(row)}
            >
              <span className="svg-icon svg-icon-md svg-icon-danger">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Code/Error-circle.svg")}
                />
              </span>
            </div>
          </OverlayTrigger>
        )}
        {row.is_active === false && (
          <OverlayTrigger
            overlay={<Tooltip id="products-delete-tooltip">Active</Tooltip>}
          >
            <div
              className="btn btn-icon btn-light btn-hover-danger btn-sm mr-3 mb-2"
              onClick={() => handleActive(row)}
            >
              <span className="svg-icon svg-icon-md svg-icon-danger">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Code/Done-circle.svg")}
                />
              </span>
            </div>
          </OverlayTrigger>
        )}
      </div>
    );
  };

  const handleActive = async (row) => {
    const id = {
      param_id: `${row.param_id}`,
      company_param_id: `${row.company_param_id}`,
      is_active: true,
    };

    const action = await showConfirmDialog(
      `Are you sure want to Acive ?<br><strong>${row.param_code}</strong>`
    );
    if (action.isConfirmed) {
      try {
        const response = await dispatch(editItem(id));
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.message);
          await window.location.reload();
        } else {
          showErrorDialog(response.payload.message);
        }
      } catch (error) {
        console.log(error);
        showErrorDialog("Something went wrong!");
      }
    }
  };

  const handleNotActive = async (row) => {
    const id = {
      param_id: `${row.param_id}`,
      company_param_id: `${row.company_param_id}`,
      is_active: false,
    };

    const action = await showConfirmDialog(
      `Are you sure want to not active?<br><strong>${row.param_code}</strong>`
    );
    if (action.isConfirmed) {
      try {
        const response = await dispatch(editItem(id));
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.message);
          await window.location.reload();
        } else {
          showErrorDialog(response.payload.message);
        }
      } catch (error) {
        console.log(error);
        showErrorDialog("Something went wrong!");
      }
    }
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      style: { minWidth: "60px" },
    },

    {
      text: "group name",
      dataField: "param_group_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "code",
      dataField: "param_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "value",
      dataField: "param_value",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "is active",
      dataField: "is_active",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: statusFormatter,
    },

    {
      text: "Action",
      dataField: "action",
      align: "center",
      formatter: actionFormatter,
    },
  ];

  const options = {
    page: page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList(totalSize),
  };
  return (
    <>
      <BootstrapTable
        remote
        striped
        noDataIndication="Data Not Found"
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden"
        bootstrap4
        bordered={true}
        keyField="no"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        hover
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>
    </>
  );
};
